module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/phone-b963ed719875d4333a14b2e9042fc7a0.svg";